import { Box, Stack } from '@mantine/core'
import {
  createFileRoute,
  Outlet,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router'
import { useLayoutEffect } from 'react'
import type { BoggleChallengeConfigurationId } from '~/boggle/challenges'
import { GamePageHeader } from '~/boggle/ui/chrome/AppLayout'
import { ChallengeCatalogScreen } from '~/boggle/ui/challenge/ChallengeCatalogScreen'
import { useBoggleModeSession } from '~/boggle/ui/state/ModeSession'

export const Route = createFileRoute('/challenges')({
  head: () => ({
    meta: [
      { title: 'Challenges — Patter' },
      {
        name: 'description',
        content: 'Browse Patter challenges',
      },
    ],
  }),
  component: ChallengesRoute,
})

function ChallengesRoute() {
  const navigate = useNavigate()
  const { clearRouteHostedGameMode } = useBoggleModeSession()
  const pathname = useRouterState({
    select: state => state.location.pathname,
  })

  const isChallengesIndex = pathname === '/challenges' || pathname === '/challenges/'

  useLayoutEffect(() => {
    if (!isChallengesIndex) {
      return
    }

    clearRouteHostedGameMode()
  }, [clearRouteHostedGameMode, isChallengesIndex])

  if (!isChallengesIndex) {
    return <Outlet />
  }

  return (
    <Stack gap={0} h="100%" mih={0}>
      <GamePageHeader />
      <Box flex={1} mih={0}>
        <ChallengeCatalogScreen
          onSelect={(configurationId: BoggleChallengeConfigurationId) => {
            void navigate({
              to: '/challenges/$challengeId',
              params: { challengeId: configurationId },
            })
          }}
        />
      </Box>
    </Stack>
  )
}
